import { fetchSalesPlanningBarcodesData } from '../../Service/ApiService';
import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const BarcodeDesign90daysController = () => {
  const REPORTS_PAYLOAD_KEY = "samplePlanningReportsPayload90Days";
  const navigate = useNavigate();
  const location = useLocation();

  const designNumber = location.state?.designNumber || '';
  const reportsPayload =
    location.state?.reportsPayload ||
    (() => {
      try {
        const raw = localStorage.getItem(REPORTS_PAYLOAD_KEY);
        return raw ? JSON.parse(raw) : {};
      } catch (e) {
        return {};
      }
    })();
  const user = JSON.parse(localStorage.getItem('user'));

  const [barcodeData, setBarcodeData] = React.useState([]);
  const [isDataLoading, setIsDataLoading] = React.useState(false);

  useEffect(() => {
    if (designNumber) {
      getData(designNumber);
    }
  }, []);

  const getData = async (designNo) => {
    setIsDataLoading(true);
    try {
      const res = await fetchSalesPlanningBarcodesData(
        user.userId,
        '',
        user.userCode,
        user.userVerticalId,
        '',
        designNo
      );

      if (res && res.success === 'true') {
        setBarcodeData(res.materialList || []);
      } else {
        setBarcodeData([]);
      }
    } catch (err) {
      console.error('Error fetching barcode data:', err);
      setBarcodeData([]);
    } finally {
      setIsDataLoading(false);
    }
  };

  const addMoreBarcode = async (designNo) => {
    setIsDataLoading(true);
    try {
      const res = await fetchSalesPlanningBarcodesData(
        user.userId,
        '',
        user.userCode,
        user.userVerticalId,
        '',
        designNo
      );

      if (res && res.success === 'true') {
        const newItems = res.materialList || [];
        if (newItems.length > 0) {
          setBarcodeData((prev) => {
            const existingBarcodes = new Set(prev.map((item) => item.barcode));
            const uniqueNew = newItems.filter((item) => !existingBarcodes.has(item.barcode));
            return [...prev, ...uniqueNew];
          });
        }
      } else {
        console.warn('No data found for this Design Number:', designNo);
      }
    } catch (err) {
      console.error('Error adding more barcode data:', err);
    } finally {
      setIsDataLoading(false);
    }
  };

  const handleRemoveBarcode = (barcode) => {
    const updatedData = barcodeData.filter((item) => item.barcode !== barcode);
    setBarcodeData(updatedData);
  };

  const handleProceed = () => {
    if (barcodeData.length === 0) {
      alert('Please add at least one barcode before proceeding.');
      return;
    }
    navigate('/sample-selection-sales-planning', { state: { barcodeData, reportsPayload } });
  };

  const handleClearButtonClick = () => {
    setBarcodeData([]);
  };

  return {
    barcodeData,
    isDataLoading,
    handleClearButtonClick,
    handleRemoveBarcode,
    handleProceed,
    addMoreBarcode
  };
};

export default BarcodeDesign90daysController;
